<!-- =========================================================================================
    File Name: Bills.vue
    Description: Displays the list of user's company bills
========================================================================================== -->

<template>
    <div class="edit-bill">
        <column-layout>
            <div class="flex flex-wrap justify-between items-start mb-8">
                <h2 class="font-light text-lg my-3">DETAIL DU CLIENT</h2>
                <div class="flex">
                    <vs-button :to="{path: '/clients' }" type="gradient" icon-pack="feather" icon="icon-chevron-left"
                               class="mr-2">
                        Retour
                    </vs-button>
                </div>
            </div>

            <vs-card class="text-left px-0" v-if="client">
                <!-- Client summary line -->
                <div class="mx-4 flex items-center justify-between">
                    <div class="flex items-center">
                        <div class="w-12 h-12 pt-1 text-xl items-center justify-center inline-flex rounded-full"
                             :class="`text-success`"
                             :style="{background: `rgba(var(--vs-success),.15)`}">
                            <i class="m-auto leading-normal fal fa-lg fa-fw fa-user"/>
                        </div>
                        <div class="mx-4 text-base leading-tight">
                            <strong>Client:</strong><br>
                            <span class="text-gray-dark">{{ client.name }}</span>
                        </div>
                    </div>
                    <div>
                        <vs-button :disabled="editable" @click="editable = true" type="border" color="primary"
                                   icon-pack="feather" icon="icon-edit">Éditer
                        </vs-button>
                    </div>
                </div>

                <vs-divider class="my-2 card-wide"/>

                <!-- Client details -->
                <section class="vx-row px-4 items-start">
                    <div class="vx-col hidden lg:block lg:w-1/5">
                        <div class="client-section-icon"></div>
                    </div>
                    <div class="vx-col w-full lg:w-4/5 pl-4 pr-8 py-3">

                        <div class="vx-row items-center text-xl mb-2">
                            <div class="vx-col w-full sm:w-1/2 mb-2">
                                <span class="text-dark">Client&nbsp;:</span>&nbsp;<span
                                class="text-gray-dark">{{ client.name }}</span>
                            </div>
                            <div class="vx-col w-full sm:w-1/2 mb-2">
                                <span class="text-dark">Société&nbsp;:</span>&nbsp;<span
                                class="text-gray-dark">{{ client.societe }}</span>
                            </div>
                        </div>

                        <!-- display -->
                        <template v-if="!editable">
                            <div class="vx-row items-center text-base mb-2">
                                <div class="vx-col w-full mb-2">
                                    <span class="text-dark">Adresse&nbsp;:</span>&nbsp;<span
                                    class="text-gray-dark">{{ client.address1 }}</span><span v-if="client.address2"
                                                                                             class="text-gray-dark"> {{
                                        client.address2
                                    }}</span>
                                    <span class="text-gray-dark"> {{ client.code_postal }} {{ client.city }}</span> -
                                    <span class="text-gray-dark">{{ client.country }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/2 mb-2">
                                    <span class="text-dark">Site web&nbsp;:</span>&nbsp;<span
                                    class="text-gray-dark"> {{ client.website }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/2 mb-2">
                                    <span class="text-dark">Teléphone</span>&nbsp;<span
                                    class="text-gray-dark"> {{ client.telephone }}</span>
                                </div>
                                <div class="vx-col w-full mb-2">
                                    <span class="text-dark">Email&nbsp;:</span>&nbsp;<span
                                    class="text-gray-dark"> {{ client.email }}</span>
                                </div>
                            </div>

                            <div class="vx-row items-center text-sm">
                                <div class="vx-col w-full sm:w-1/3 mb-2">
                                    <span class="text-dark">N°&nbsp;RCS&nbsp;:</span>&nbsp;<span class="text-gray-dark"> {{
                                        client.rcs
                                    }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/3 mb-2">
                                    <span class="text-dark">N°&nbsp;Siret&nbsp;:</span>&nbsp;<span
                                    class="text-gray-dark"> {{ client.siret }}</span>
                                </div>
                                <div class="vx-col w-full sm:w-1/3 mb-2">
                                    <span class="text-dark">N°&nbsp;TVA&nbsp;:</span>&nbsp;<span class="text-gray-dark"> {{
                                        client.tva_intracom
                                    }}</span>
                                </div>
                            </div>
                        </template>

                        <client-form
                            v-else
                            :client="client"
                            @onCancel="editable = false"
                            @onSaved="editable = false;refreshData()"
                            :clientLoading="clientLoading"
                        />
                        <!-- ./display -->
                    </div>
                </section>
                <!-- ./Client details -->

                <vs-divider class="mt-0 mb-2 card-wide"/>
                <!-- Associated Bills -->

                <vs-tabs ref="tabs">
                    <vs-tab label="Factures associées">
                        <div class="tab-text pt-6" v-if="bills && bills.length">
                            <vs-table id="bills-view" :data="bills">
                                <template slot="thead">
                                    <vs-th style="width:20px">&nbsp;</vs-th>
                                    <vs-th sort-key="num">Facture</vs-th>
                                    <vs-th sort-key="emission_date">Date émission</vs-th>
                                    <vs-th sort-key="due_date">Date échéance</vs-th>
                                    <vs-th sort-key="amount_ttc" class="amount_ttc">Montant TTC</vs-th>
                                    <vs-th sort-key="status.name">Statut</vs-th>
                                    <vs-th></vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="index" v-for="(file, index) in data">
                                        <vs-td style="width:20px">
                                            <div
                                                class="w-12 h-12 pt-1 text-xl align-center justify-center inline-flex rounded-full"
                                                :class="`text-${ currentBillStatus(data[index].status.code).color }`"
                                                :style="{background: `rgba(var(--vs-${ currentBillStatus(data[index].status.code).color }),.15)`}">
                                                <i class="m-auto leading-normal fal fa-lg fa-fw fa-file-invoice"/>
                                            </div>
                                        </vs-td>

                                        <vs-td :data="data[index].number" class="whitespace-nowrap">
                                            <!-- <span class="text-muted">Facture</span><br> -->
                                            <span>N°{{ data[index].number }}</span>
                                        </vs-td>

                                        <vs-td :data="data[index].created_at">
                                            <template v-if="data[index].created_at">
                                                {{ data[index].created_at | moment('DD/MM/YYYY') }}
                                            </template>
                                        </vs-td>

                                        <vs-td :data="data[index].due_date">
                                            <template v-if="data[index].due_date">
                                                {{ data[index].due_date | moment('DD/MM/YYYY') }}
                                            </template>
                                        </vs-td>

                                        <vs-td :data="data[index].amount_ttc" class="text-right">
                                            <span class="text-success text-nowrap">{{
                                                    Number(data[index].amount_ttc) | numFormat('$ 0,0.00')
                                                }}</span>&nbsp;<span class="text-muted">/</span> &nbsp;<span
                                            class="text-danger text-nowrap">{{
                                                Number(data[index].amount_ttcRegle) | numFormat('$ 0,0.00')
                                            }}</span>
                                        </vs-td>

                                        <vs-td :data="data[index].status.code">
                                            <vs-chip :color="currentBillStatus(data[index].status.code).color"
                                                     style="white-space: nowrap;">
                                                <strong>{{ currentBillStatus(data[index].status.code).status }}</strong>
                                            </vs-chip>
                                        </vs-td>
                                        <vs-td :data="data[index].id" class="px-3">
                                            <div class="flex justify-end">
                                                <vs-button class="ml-2 text-nowrap" size="small" type="border"
                                                           color="primary"
                                                           :to="{ name: 'Editer une facture', params: { id: data[index].id }}">
                                                    <i class="far fa-file-invoice fa-lg mr-2"/>Afficher<span
                                                    class="hidden xl:inline"> la facture</span></vs-button>
                                            </div>
                                        </vs-td>

                                    </vs-tr>
                                </template>
                            </vs-table>

                        </div>
                        <div class="tab-text" v-else>
                            <div class="text-center text-base py-6 text-gray"><i class="fal fa-eye-slash mr-2"></i>Aucune
                                facture associée à ce client.
                            </div>
                        </div>
                    </vs-tab>
                </vs-tabs>
                <!-- ./Associated Bills -->
            </vs-card>

            <empty-card v-else/>

            <!--  ASIDE -->
            <template slot="aside">

                <h2 class="font-light mt-6 text-lg mb-8 uppercase">Liste des contacts</h2>
                <vs-card class="py-3">

                    <section v-if="client.interlocuteurs && client.interlocuteurs.length > 0">
                        <div
                            v-for="(person, index) in client.interlocuteurs" :key="index">
                            <div class="flex mb-4">
                                <div class="w-2/12 text-center">
                                    <div
                                        class="w-12 h-12 pt-1 text-xl align-center justify-center inline-flex rounded-full text-success"
                                        style="width: 40px; background: rgba(var(--vs-success),.15)">
                                        <i class="m-auto leading-normal fal fa-lg fa-fw fa-user"/>
                                    </div>
                                </div>
                                <div class="w-9/12">
                                    <div>
                                        <h4 class="h5 font-medium">{{ person.gender }} {{ person.firstname }}
                                            {{ person.lastname }}</h4>
                                        <p class="text-sm text-muted mb-1">{{ person.job }}</p>
                                        <ul class="fa-ul ml-6 text-base mb-3">
                                            <li v-if="person.email"><span class="fa-li"><i
                                                class="text-muted far fa-envelope"/></span>{{ person.email }}
                                            </li>
                                            <li v-if="person.phone"><span class="fa-li"><i
                                                class="text-muted far fa-phone"/></span>{{ person.phone }}
                                            </li>
                                        </ul>
<!--                                        <div class="flex">-->
<!--                                            <vs-button :disabled="activeModalContact" @click="editContactAt(index)"-->
<!--                                                       color="primary" type="border" size="small" icon-pack="feather"-->
<!--                                                       icon="icon-edit" class="px-3 py-1"><span-->
<!--                                                class="text-xs">Éditer</span></vs-button>-->
<!--                                            <vs-button :disabled="activeModalContact" @click="deleteContactAt(index)"-->
<!--                                                       color="danger" type="border" size="small" icon-pack="feather"-->
<!--                                                       icon="icon-trash" class="ml-2 px-3 py-1"><span class="text-xs">Supprimer</span>-->
<!--                                            </vs-button>-->
<!--                                        </div>-->
                                    </div>
                                </div>
                            </div>
                            <vs-divider v-if="index < client.interlocuteurs.length - 1"/>
                        </div>
                    </section>
                    <div v-else class="text-center text-base py-6 text-gray"><i class="fal fa-user-slash mr-2"></i>Aucun
                        contact renseigné
                    </div>


                    <div slot="footer">
                        <vs-divider/>
                        <vs-row vs-justify="flex-end" class="pb-10 pr-3">
                            <vs-button @click="addClientContact()" type="border" color="primary" icon-pack="feather"
                                       icon="icon-user-plus">
                                Ajouter un contact
                            </vs-button>
                        </vs-row>
                    </div>
                </vs-card>
            </template>

        </column-layout>


        <vs-prompt
            title="Editer un interlocuteur"
            @cancel="clearContactForm"
            @accept="saveContactForm"
            :is-valid="!isContactFormInvalid"
            accept-text="Enregistrer"
            cancel-text="Annuler"
            :active.sync="activeModalContact">
            <div class="contact-form">
                <i class="far fa-info-circle mr-2 mb-4"></i>Veuillez saisir les informations ci-dessous :
                <!-- <pre>
                  {{ contactForm }}
                </pre> -->
                <select name="gender" id="gender" class="py-3 mb-2" v-model="contactForm.gender">
                    <option v-for="option in genderOptions" :key="option" :value="option">{{ option }}</option>
                </select>

                <vs-input
                    icon-pack="feather"
                    icon="icon-user"
                    class="w-full mb-2"
                    name="firstname"
                    id="firstname"
                    v-model="contactForm.firstname"
                    placeholder="prénom"
                />
                <vs-input
                    icon-pack="feather"
                    icon="icon-user"
                    name="lastname"
                    id="lastname"
                    v-model="contactForm.lastname"
                    class="w-full mb-2"
                    placeholder="nom"
                />

                <vs-input
                    icon-pack="feather"
                    icon="icon-crosshair"
                    name="job"
                    id="job"
                    class="w-full mb-2"
                    v-model="contactForm.job"
                    placeholder="Fonction"
                />
                <vs-input
                    icon-pack="feather"
                    icon="icon-mail"
                    name="email"
                    id="email"
                    type="email"
                    class="w-full mb-2"
                    v-model="contactForm.email"
                    placeholder="Email"
                    :danger="contactForm.email ? isInvalid(contactForm.email, 'email') : false"
                    danger-text="Vous devez saisir un email valide"
                    val-icon-danger="icon-x"
                    val-icon-pack="feather"
                />
                <vs-input
                    icon-pack="feather"
                    icon="icon-phone"
                    class="w-full mb-4"
                    name="tel"
                    id="tel"
                    type="tel"
                    v-model="contactForm.phone"
                    placeholder="Téléphone"
                    :danger="contactForm.phone ? isInvalid(contactForm.phone, 'tel') : false"
                    danger-text="Vous devez saisir un téléphone valide"
                    val-icon-danger="icon-x"
                    val-icon-pack="feather"
                />

            </div>
        </vs-prompt>

    </div>
</template>

<script>
// @ is an alias to /src
import ColumnLayout from '@/layouts/columns/ColumnLayout.vue'
import ClientForm from '@/layouts/forms/ClientForm'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VxTimeline from '@/components/timeline/VxTimeline'
import billMixins from '@/mixins/billMixins'
import {formValidationMixins} from '@/mixins/formValidationMixins.js'

import {mapState, mapActions} from 'vuex'

// import { InterlocutorInterface } from '@/interfaces/ClientInterface.js'

export default {
  name: 'EditClient',
  mixins: [billMixins, formValidationMixins],
  components: {
    ColumnLayout,
    ClientForm,
    VuePerfectScrollbar,
    VxTimeline
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      activeModalContact: false,
      editable: false,
      contactForm: {},
      genderOptions: [
        'M',
        'Mme',
        'Autre'
      ],
      contactList: [],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    ...mapState({
      bills: state => state.bill.bills,
      client: state => state.client.client,
      clientLoading: state => state.client.clientLoading
    }),
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    // clientBills () {
    //   return this.bills.filter(b => b.id === this.client.id)
    // },

    isContactFormInvalid () {
      return (
        (this.contactForm.email ? this.isInvalid(this.contactForm.email, 'email') : false) ||
                (this.contactForm.phone ? this.isInvalid(this.contactForm.phone, 'tel') : false)
      )
    }
  },

  created () {
    this.refreshData()
  },

  methods: {
    ...mapActions('client', ['getClient', 'saveClient', 'deleteClientInterlocuteur', 'editClientInterlocuteur', 'addClientInterlocuteur']),
    ...mapActions('bill', ['getClientBills']),

    refreshData () {
      this.$vs.loading()
      this.getClient(this.id).then(() => {
        this.getClientBills({
          id: this.client.id,
          page: 1,
          limit: 100000
        })
        this.$vs.loading.close()
      }).catch(() => {
        this.$vs.loading.close()
      })
    },

    editContactAt (index) {
      // fill the form with current contact at index...
      this.contactForm = {...this.client.interlocuteurs[index]}
      //call the prompt form
      this.activeModalContact = true
    },

    deleteContactAt (index) {

      const interlocuteurs = [...this.client.interlocuteurs]
      interlocuteurs.splice(index, 1)

      this.saveClient({
        id: this.client.id,
        interlocuteurs
      })
        .then(() => {
          this.refreshData()
        })
    },

    clearContactForm () {
      this.contactForm = {
        id: -1,
        gender: 'M',
        firstname: '',
        lastname: '',
        job: '',
        email: '',
        phone: ''
      }
    },

    saveContactForm () {
      if (this.isContactFormInvalid) return false

      const interlocuteurs = [...this.client.interlocuteurs]

      if (this.contactForm.id !== -1) {
        //update de l'interlocuteur dans le tableau existant

        interlocuteurs.forEach((interlocuteur, index) => {
          if (interlocuteur.id === this.contactForm.id) {
            interlocuteurs[index] = {...this.contactForm}
          }
        })
      } else {
        //ajout d'un nouvel interlocuteur
        interlocuteurs.push(this.contactForm)
      }

      // save and refresh the list
      this.saveClient({
        id: this.client.id,
        interlocuteurs
      })
        .then(() => {
          this.refreshData()
        })
    },

    addClientContact () {
      this.clearContactForm()
      this.activeModalContact = true
    },

    // client form

    saveClientForm () {
      // console.log('form saved')
      this.editable = false
    }
  }
}
</script>

<style lang="scss">
.client-section-icon {
    background: url('~@/assets/images/icons/section-user-icon.svg') no-repeat right center;
    height: 100%;
    min-height: 178px;
    width: calc(100% + 2.15rem);
    max-width: 170px;
    margin: -.6rem 0 0 -1.6rem;
}

.card-wide {
    margin-left: -0.6rem;
    margin-right: -0.6rem;
    width: calc(100% + 1.2rem);
}

</style>
